'use client';

import Image from 'next/image';
import AppleStoreBadgeDesktop from '@/components/icons/AppleStoreIcon/AppleStoreIcon';
import GooglePlayBadgeDesktop from '@/components/icons/GooglePlayIcon/GooglePlayIcon';
import { trackCtaClick } from '@/utils/tracking';

interface DesktopDownloadSectionProps {
  qrCodeImage?: string;
  badgeUrl: string;
  appleAriaLabel?: string;
  googleAriaLabel?: string;
}

export const DesktopDownloadSection = ({
  qrCodeImage,
  badgeUrl,
  appleAriaLabel = 'Download on the iOS App Store',
  googleAriaLabel = 'Download on Google Play Store',
}: DesktopDownloadSectionProps) => {
  const qrCodeAlt = 'QR code to download the Tempcover app';

  return (
    <div className="hidden flex-col items-center md:flex">
      {qrCodeImage && (
        <div className="mb-6">
          <Image src={qrCodeImage} alt={qrCodeAlt} width={144} height={144} className="rounded-lg" />
        </div>
      )}

      {/* Store Badges */}
      <div className="flex justify-center gap-1">
        <a
          href={badgeUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${appleAriaLabel} (opens in new tab)`}
          onClick={() => trackCtaClick('App Store Badge', 'app_store')}
          className="focus-visible:ring-primary h-[41px] w-[124.307px] rounded-sm transition-all focus-visible:ring-2 focus-visible:ring-offset-2"
        >
          <span aria-hidden="true">
            <AppleStoreBadgeDesktop />
          </span>
        </a>
        <a
          href={badgeUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${googleAriaLabel} (opens in new tab)`}
          onClick={() => trackCtaClick('Google Play Badge', 'google_play')}
          className="focus-visible:ring-primary h-[41px] w-[136px] rounded-sm transition-all focus-visible:ring-2 focus-visible:ring-offset-2"
        >
          <span aria-hidden="true">
            <GooglePlayBadgeDesktop />
          </span>
        </a>
      </div>
    </div>
  );
};
